import image1 from "../assets.bak/t-image1.png";
import image2 from "../assets.bak/t-image2.png";
import image3 from "../assets.bak/t-image3.png";

export const testimonialsData = [
  {
    image: image1,
    review:
      "The first rule of Fight Club is you do not talk about Fight Club...",
    name: 'TYLER DURDEN',
    status : 'COACH'
  },
  {
    image: image2,
    review: 'Stop trying to control everything and just let go. Let go! This is your life, and it is ending one minute at a time.',
    name: 'ROBERT PAULSON',
    status: 'CUSTOMER'
  },
  {
    image : image3,
    review:'Our great war is a spiritual war. Our great depression is our lives. We are a by-product of a lifestyle obsession.',
    name: 'ANGEL FACE',
    status: "CUSTOMER"
  }
];
